import Joi from '@hapi/joi';

export const failureModeCreateSchema = Joi.object().keys({
    customName: Joi.string().allow(null, ''),
    analysisRemarks: Joi.string().allow(null, ''),
    verificationRemarks: Joi.string().allow(null, ''),
    maintenanceRemarks: Joi.string().allow(null, ''),
    defaultFailureModeId: Joi.string().allow(null),
    metaData: Joi.object().allow(null),
    // analysisRiskScore: Joi.number().integer().allow(null),
    // analysisTotalScore: Joi.number().integer().allow(null),
    // ramssheepAvailability: Joi.number().integer().allow(null),
    // ramssheepMaintainability: Joi.number().integer().allow(null),
    // ramssheepSafety: Joi.number().integer().allow(null),
    // ramssheepSecurity: Joi.number().integer().allow(null),
    // ramssheepHealth: Joi.number().integer().allow(null),
    // ramssheepEnvironment: Joi.number().integer().allow(null),
    // ramssheepEconomics: Joi.number().integer().allow(null),
    // ramssheepPolitics: Joi.number().integer().allow(null),
    // verificationRiskScore: Joi.number().integer().allow(null),
    // verificationTotalScore: Joi.number().integer().allow(null),
    // maintenanceRiskScore: Joi.number().integer().allow(null),
    // maintenanceTotalScore: Joi.number().integer().allow(null),
    // analysisVerificationQuestion: Joi.string().allow(null),

    analysisRamsR: Joi.string().allow(null),
    analysisRamsA: Joi.string().allow(null),
    analysisRamsS: Joi.string().allow(null),
    analysisRamsC: Joi.string().allow(null),
    analysisRamsEc: Joi.string().allow(null),
    analysisRamsEnv: Joi.string().allow(null),
    analysisRamsP: Joi.string().allow(null),

    verificationRamsR: Joi.string().allow(null),
    verificationRamsA: Joi.string().allow(null),
    verificationRamsS: Joi.string().allow(null),
    verificationRamsC: Joi.string().allow(null),
    verificationRamsEc: Joi.string().allow(null),
    verificationRamsEnv: Joi.string().allow(null),
    verificationRamsP: Joi.string().allow(null),

    maintenanceRamsR: Joi.string().allow(null),
    maintenanceRamsA: Joi.string().allow(null),
    maintenanceRamsS: Joi.string().allow(null),
    maintenanceRamsC: Joi.string().allow(null),
    maintenanceRamsEc: Joi.string().allow(null),
    maintenanceRamsEnv: Joi.string().allow(null),
    maintenanceRamsP: Joi.string().allow(null),

    analysisRamsTotalPriority: Joi.string().allow(null),
    verificationRamsTotalPriority: Joi.string().allow(null),
    maintenanceRamsTotalPriority: Joi.string().allow(null),

    analysisRamsWeightedPriority: Joi.string().allow(null),
    verificationRamsWeightedPriority: Joi.string().allow(null),
    maintenanceRamsWeightedPriority: Joi.string().allow(null),
});
